import { render, staticRenderFns } from "./ResponsiveIconButton.vue?vue&type=template&id=73236241&scoped=true&"
import script from "./ResponsiveIconButton.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveIconButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73236241",
  null
  
)

export default component.exports